__turbopack_context__.v({
  "bigImage": "[video]-module-scss-module__g05Tea__bigImage",
  "h1": "[video]-module-scss-module__g05Tea__h1",
  "h2": "[video]-module-scss-module__g05Tea__h2",
  "mainContent": "[video]-module-scss-module__g05Tea__mainContent",
  "trailerContainer": "[video]-module-scss-module__g05Tea__trailerContainer",
});
